import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

export const SelectorSkeleton = () => (
  <Skeleton data-testid='selector-skeleton' duration={1} className='h-10 rounded-full bg-gray-50' />
);
